<template>
  <span class="title homeLogoHeader" @click="handleHome">
    <img src="fd-logo.svg" width="250">
  </span>
</template>

<script>
import router from "../../router";

export function handleHome() {
  router.push("/");
}

export default {
  name: "HomeLogo",
  setup() {
    return {
      //functions
      handleHome
    };
  }
};
</script>

<style scoped>
.homeLogoHeader {
  display: inline-flex;
  margin-bottom: -10px;
  cursor: pointer;
  align-items: flex-end;
}
</style>